import React from "react";
import { makeStyles } from "@mui/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";

const customStyles = makeStyles({
  headerWrapper: {
    marginTop:"-120px",
    width: "90%",
    display: "flex",
    marginRight: "auto",
    marginLeft: "auto",
    position: "relative",
    flexWrap: "wrap",
    alignContent: "flex-start",
    flexDirection: "column",
 fontFamily: "Montserrat",
  },
  headerContainer: {
    textAlign: "left",
    maxWidth: "700px",
  },
  header: {
    margin: "0px",
    fontWeight: "600",
    letterSpacing: "-0.027em",
    lineHeight: "1.1",
    textTransform: "none",
    fontSize: "64px",
    fontWeight: "600", 
        color: "black",
        fontFamily: "Montserrat",
            marginLeft:"90px"

  },
  headerBodyContainer: {
    maxWidth: "520px",
    fontSize: "20px",
    fontWeight: "300",
       color: "black",
        fontFamily: "Montserrat",
            marginLeft:"90px"

  },
  headerBtnWrapper: {
    display: "flex",
    marginTop: "76px",
    gap: "16px",
        marginLeft:"90px"

  },
  divider: {
    marginTop: "32px",
    color: "#80808047",
    width: "346px",
  },
  headerUsers: {
    marginTop: "32px",
    fontWeight: "400",
    display: "flex",
    width: "330px",
    fontSize: "18px",
    alignItems: "center",
    gap: "10px",
  },
 // Media Query for Extra Small Screens (<320px) 
 '@media (max-width: 319px)': {
     headerWrapper: {
    marginLeft:"-20px",
    marginTop:"-40px",
    width: "90%",
    display: "flex",
    position: "relative",
    flexWrap: "wrap",
    alignContent: "flex-start",
    flexDirection: "column",
 fontFamily: "Montserrat",
  },
  header: {
    fontSize: "36px",  
    fontFamily: "Montserrat",
  },
  headerBodyContainer: {
    fontSize: "16px",  
    maxWidth: "100%",
    fontFamily: "Montserrat",
  },
  headerBtnWrapper: {
    flexDirection: "column",  
    marginTop: "60px",  
  },
  divider: {
    width: "100%", 
  },
  headerUsers: {
    fontSize: "16px", 
    width: "100%",
    justifyContent: "center",
    fontFamily: "Montserrat",
  },
},

// Media Query for Small Screens (320px - 480px)
'@media (min-width: 320px) and (max-width: 480px)': {
    headerWrapper: {
    marginLeft:"-20px",
    marginTop:"-40px",
    width: "90%",
    display: "flex",
    position: "relative",
    flexWrap: "wrap",
    alignContent: "flex-start",
    flexDirection: "column",
 fontFamily: "Montserrat",
  },
  header: {
    fontSize: "42px",  
    fontFamily: "Montserrat",
  },
  headerBodyContainer: {
    fontSize: "18px", 
    maxWidth: "100%", 
    fontFamily: "Montserrat",
  },
  headerBtnWrapper: {
    flexDirection: "column",  // Stack buttons vertically
    marginTop: "80px",  // More space between buttons
  },
  divider: {
    width: "100%",  // Divider width to 100% of screen width
  },
  headerUsers: {
    width: "100%",  // Full width for users section
    fontSize: "18px",  // Slightly larger font for users info
    justifyContent: "center", 
    marginBottom: "-40px",  // Adjust margin for spacing
    fontFamily: "Montserrat",
  },
},

// Media Query for Medium Screens (481px - 768px)
'@media (min-width: 481px) and (max-width: 768px)': {
     headerWrapper: {
    marginLeft:"-20px",
    marginTop:"-40px",
    width: "90%",
    display: "flex",
    position: "relative",
    flexWrap: "wrap",
    alignContent: "flex-start",
    flexDirection: "column",
 fontFamily: "Montserrat",
  },
  header: {
    fontSize: "48px",  // Larger font for medium screens
    fontFamily: "Montserrat",
  },
  headerBodyContainer: {
    fontSize: "20px",  // Standard font size for medium screens
    maxWidth: "100%",  // Container full width
    fontFamily: "Montserrat",
  },
  headerBtnWrapper: {
    flexDirection: "row",  // Button layout to row
    marginTop: "90px",  // Adjust top margin for better spacing
  },
  divider: {
    width: "80%",  // Divider width for medium screens
  },
  headerUsers: {
    width: "80%",  // Adjust width for users section
    fontSize: "18px",  // Keep font size consistent
    justifyContent: "center", 
    fontFamily: "Montserrat",
  },
},

// Media Query for Large Screens (769px - 1024px)
'@media (min-width: 769px) and (max-width: 1024px)': {
    headerWrapper: {
    marginLeft:"-20px",
    marginTop:"-40px",
    width: "90%",
    display: "flex",
    position: "relative",
    flexWrap: "wrap",
    alignContent: "flex-start",
    flexDirection: "column",
 fontFamily: "Montserrat",
  },
  header: {
    fontSize: "56px",  // Larger font for larger screens
    fontFamily: "Montserrat",
  },
  headerBodyContainer: {
    fontSize: "22px",  // Increase body font size slightly
    maxWidth: "600px",  // Set a max width for body container
    fontFamily: "Montserrat",
  },
  headerBtnWrapper: {
    flexDirection: "row",  // Maintain row layout for buttons
    marginTop: "100px",  // Adjust space between buttons
  },
  divider: {
    width: "70%",  // Divider width for larger screens
  },
  headerUsers: {
    width: "70%",  // Adjust user section width
    fontSize: "20px",  // Slightly larger font for users info
    justifyContent: "flex-start",  // Align users section to left
    fontFamily: "Montserrat",
  },
},
});

const Header = () => {
  const classes = customStyles();
  const navigate = useNavigate();

  return (
   <div className={classes.headerWrapper}>
  <div className={classes.headerContainer}>
    <h1 className={classes.header}>
      Smart snack pickup. No cash, no queues.
    </h1>
  </div>
  <div className={classes.headerBodyContainer}>
    Enter your Phone Number & Alpin. Grab your snack. We’ll do the rest.
  </div>
  <div className={classes.headerBtnWrapper}>
    <div
    style={{backgroundColor:"black",fontFamily:"Montserrat"}}
      className={"purpleBtn"}
      onClick={() => {
        navigate(routes.USER_LOGIN);
      }}
    >
      Log In <ArrowForwardIcon />
    </div>
    <div
        style={{backgroundColor:"black",fontFamily:"Montserrat"}}
      className={"purpleBtn"}
      onClick={() => {
        navigate(routes.SIGN_UP);
      }}
    >
      Create ALPIN <ArrowForwardIcon />
    </div>
  </div>
  <div className={classes.divider} />
  <div className={classes.headerUsers}   style={{color:"black",fontFamily:"Montserrat"}}>
    <h1 className={classes.header} style={{color:"black",fontFamily:"Montserrat"}}>1000</h1>
    <span style={{color:"black",fontFamily:"Montserrat"}}>Instant snack pickups completed</span>
  </div>
</div>

  );
};

export default Header;
